import {ExchangePriceWithRelations, ProductWithRelations} from "@aparraga/ahoracrypto-api-sdk/sdk";


export class CartItem {

  public product: ProductWithRelations;
  public exchangePrice: ExchangePriceWithRelations;
  public quantity: number;
  public totalToPayFor: number;

  /**
   * If cryptoQuantityCanVary, the amount to pay for is inmutable but the amount of crypto can vary.
   * Otherwise, the oposite way: the amount of crypto is inmutable but the total to pay for can vary.
   */
  public cryptoQuantityCanVary: boolean;
  public walletAddress: string;
  public walletNetwork: string;
  public walletMemo: string;

  public isEqual(item: CartItem): boolean {
    return this.product.id == item.product.id &&
           this.exchangePrice.reservationToken == item.exchangePrice.reservationToken &&
           this.quantity == item.quantity &&
           this.walletAddress == item.walletAddress &&
           this.walletNetwork == item.walletNetwork &&
           this.walletMemo == item.walletMemo;
  }

}
